import {
  UAPPlacementTypeAlias as EPT,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

export const AdAssetsStepSection = {
  FinalUrl: 'final-url',
  Image: 'image',
  ShortHeadline: 'short-headline',
  LongHeadline: 'long-headline',
  Description: 'description',
  BusinessName: 'business-name',
};

export const AllAdAssetsStepSections = [
  AdAssetsStepSection.FinalUrl,
  AdAssetsStepSection.Image,
  AdAssetsStepSection.ShortHeadline,
  AdAssetsStepSection.LongHeadline,
  AdAssetsStepSection.Description,
  AdAssetsStepSection.BusinessName,
];

export const AdPreviewSurface = {
  MSN: 'MSN',
  Bing: 'Bing',
  Edge: 'Edge',
  Outlook: 'Outlook',
};

export const AdPreviewSurfaceHeaderText = {
  [AdPreviewSurface.MSN]: 'msn.com',
  [AdPreviewSurface.Bing]: 'Bing Search',
  [AdPreviewSurface.Edge]: 'Edge',
  [AdPreviewSurface.Outlook]: 'Outlook',
};

export const AdPreviewSurfacePlacementKeys = {
  [AdPreviewSurface.MSN]: ['msan_191x100', 'edge_178x100', 'msan_150x100', 'msan_1x1', 'msan_133x100'],
  [AdPreviewSurface.Bing]: ['mma_191x100', 'bing_text'],
  [AdPreviewSurface.Edge]: ['mma_191x100', 'edge_178x100'],
  [AdPreviewSurface.Outlook]: ['outlook_text_mobile', 'outlook_text_web'],
};

export const AdPreviewOverideStylesByKey = {
  mma_191x100: { imagePreviewHeight: 153, imagePreviewWidth: 292 },
  edge_178x100: { imagePreviewHeight: 220, imagePreviewWidth: 390 },
  msan_191x100: { imagePreviewHeight: 200, imagePreviewWidth: 382 },
  msan_150x100: { imagePreviewHeight: 200, imagePreviewWidth: 300 },
};

export const AdPreviewDataProps = [
  'url',
  'displayUrl',
  'shortHeadline',
  'longHeadline',
  'description',
  'businessName',
];

export const MaxImageCount = 20;

export const MinHeadlineCount = 3;
export const MaxHeadlineCount = 12;

export const MinLongHeadlineCount = 1;
export const MaxLongHeadlineCount = 5;

export const MinDescriptionCount = 2;
export const MaxDescriptionCount = 5;

export const adPreviewConfig = [{
  placementSetName: AdPreviewSurface.MSN,
  placementTypes: [
    EPT.Responsive.MSAN.WideImage,
    EPT.Responsive.MSAN.MSEdgeSingleCarousel,
    EPT.Responsive.MSAN.MSNInArticle,
    EPT.Responsive.MSAN.SquareImage,
    EPT.Responsive.MSAN.MSNSmallHeadline,
  ],
}, {
  placementSetName: AdPreviewSurface.Bing,
  placementTypes: [
    EPT.Responsive.MMA.LandscapeImage,
    EPT.Responsive.BingSearch.Text,
  ],
}, {
  placementSetName: AdPreviewSurface.Edge,
  placementTypes: [
    EPT.Responsive.MSAN.MSEdgeSingleCarousel, EPT.Responsive.MMA.LandscapeImage,
  ],
}, {
  placementSetName: AdPreviewSurface.Outlook,
  placementTypes: [
    EPT.Responsive.Outlook.Mobile, EPT.Responsive.Outlook.Web,
  ],
}];

export const extraPlacementInfo = {
  [EPT.Responsive.MSAN.WideImage]: {
    aspectRatioUIString: '1.91:1',
    previewTitle: _TL_('MSN feed'),
    customClassName: 'msan_191x100',
    imagePreviewHeight: AdPreviewOverideStylesByKey.msan_191x100.imagePreviewHeight,
  },
  [EPT.Responsive.MSAN.MSEdgeSingleCarousel]: {
    aspectRatioUIString: '1.78:1',
    previewTitle: _TL_('Microsoft Edge single carousel'),
    customClassName: 'edge_178x100',
    imagePreviewHeight: AdPreviewOverideStylesByKey.edge_178x100.imagePreviewHeight,
  },
  [EPT.Responsive.MSAN.MSNInArticle]: {
    aspectRatioUIString: '1.5:1',
    previewTitle: _TL_('MSN in-article ad'),
    customClassName: 'msan_150x100',
    imagePreviewHeight: AdPreviewOverideStylesByKey.msan_150x100.imagePreviewHeight,
  },
  [EPT.Responsive.MSAN.SquareImage]: {
    aspectRatioUIString: '1:1',
    previewTitle: _TL_('MSN square image'),
    customClassName: 'msan_1x1',
  },
  [EPT.Responsive.MSAN.MSNSmallHeadline]: {
    aspectRatioUIString: '1.33:1',
    previewTitle: _TL_('MSN small headline'),
    customClassName: 'msan_133x100',
  },
  [EPT.Responsive.MMA.LandscapeImage]: {
    aspectRatioUIString: '1.91:1',
    previewTitle: _TL_('Landscape Image Multimedia Ad'),
    customClassName: 'mma_191x100',
    imagePreviewHeight: AdPreviewOverideStylesByKey.mma_191x100.imagePreviewHeight,
  },
  [EPT.Responsive.BingSearch.Text]: {
    aspectRatioUIString: '',
    previewTitle: _TL_('Bing search ad'),
    customClassName: 'bing_text',
  },
  [EPT.Responsive.Outlook.Mobile]: {
    aspectRatioUIString: '',
    previewTitle: _TL_('Microsoft Outlook web (mobile)'),
    customClassName: 'outlook_text_mobile',
  },
  [EPT.Responsive.Outlook.Web]: {
    aspectRatioUIString: '',
    previewTitle: _TL_('Microsoft Outlook web (computer)'),
    customClassName: 'outlook_text_web',
  },
};

